module.exports = __webpack_public_path__ + "img/fa16845.png";